module.exports = __webpack_public_path__ + "1283e1ca85caf565a28e52cd4f450f4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_75.jpg
// module id = 1755
// module chunks = 5